module.exports = __webpack_public_path__ + "d085a4d76387addb96d6c27103d8ea01.png";